import { getSessionId } from '@utils/getSessionId'

interface Options {
    dailyId?: string
    permanentId?: string
    sessionId?: string
}

function getAuthHeaders(options?: Options) {
    const headers: Record<string, string> = {}

    if (options == null) {
        return headers
    }

    const sessionId = getSessionId() ?? options.sessionId

    if (sessionId) {
        headers['x-sessionid'] = sessionId
    }

    if (options.dailyId) {
        headers['x-dailyid'] = options.dailyId
    }

    if (options.permanentId) {
        headers['x-permanentid'] = options.permanentId
    }

    return headers
}

export default getAuthHeaders
